import React from "react";
import Layout from "../../layouts/Layout";
import InfoList from "./infoList";
import ProfileImage from "./ProfileImage";
import ProfileTab from "./ProfileTab";
import ProfileStatus from "./ProfileStatus";
import PenEdit from '../../components/icons/PenEdit';
import FileDownload from '../../components/icons/FileDownload';
import BButton from '../../components/general/BButton';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import moment from "moment";
import { useNavigate } from "react-router-dom";
import apiService from '../../utils/api.service';
import helper from '../../utils/helper';
import Lineliff from '../../components/LineLiff';
import _ from 'lodash'
import { connect } from "react-redux";
import actions from "../../redux/actions";

class Profile extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      currentStatus: "Success" , // Error Wait Success
      memberId: null,
      imageProfile: '',
      resumeFile: '',
      statusExpire: null,
      memberPayment: null,
      profile: {
        myRecommenderCode: '',
        memberCode: '',
        fullname: '',
        identificationNo: '',
        birthDate: '',
        phone: '',
        email: '',
        address: '',
        licenseNo: '',
        position: '',
        educationQuality: '',
        workHistory: ''
      },
      reasonWorkList: [],
      bankDetail: {
        bank: '',
        bankAccountNo: '',
      },
      selectTab: 0,
      selectYear: moment().format('YYYY'),
      taxYear_option: helper.GEN.OPTION_YEAR(),
      selectTaxYear: []
    }
    this.cbLineLiff = this.cbLineLiff.bind(this)
  }
  componentDidMount () {
    const statusExpire = moment().format('YYYY-MM-DD')
    this.setState({ statusExpire: statusExpire })
    this.LoadProfile()
    // this.SearchTaxCertificate()
  }

  cbLineLiff (e) {
    this.LoadProfile()
  }
  toStatus (type) {
    // null || 3 สีแดง
    // 1 สีเหลือง
    // 2 สีเขียว
    if (type == null || type == 3) {
      return "Error"
    } else if (type == 1 ){
      return "Wait"
    } else if (type == 2 ){
      return "Success"
    }
    return "Error"
  }
  async LoadProfile() {
    try {
      console.log('props >>', this.props?.user?.lineId?.memberId)
      const payload = { memberId: this.props?.user?.lineId?.memberId }
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.Profile.SearchMember(payload, header)
      if (resData.resultCode === "20000") {
        const data = _.cloneDeep(resData.data)
        // console.log('data >>', data)
       
        let { memberId } = this.state
        let { imageProfile, resumeFile, currentStatus, statusExpire } = this.state
        let { profile, reasonWorkList, bankDetail } = this.state

        memberId = data.memberId
        imageProfile = data.picture
        resumeFile = data.resumeFile
        // currentStatus = this.toStatus(2)
        currentStatus = this.toStatus(data.memberPayment?.paymentStatus)
        statusExpire = data.expiryDate
        // statusExpire = '2023-02-27T17:00:00.000Z'

        profile.myRecommenderCode = data.myRecommenderCode || '-'
        profile.memberCode = data.memberCode
        profile.fullname = `${data.firstName || ''} ${data.lastName || ''}`
        profile.identificationNo = data.identificationNo
        profile.birthDate = moment(data.birthDate).format('DD/MM/YYYY')
        profile.phone = data.phone
        profile.email = data.email
        profile.address = data.address
        profile.licenseNo = data.licenseNo
        profile.position = data.position
        profile.educationQuality = data.education
        profile.workHistory = data.education

        reasonWorkList = data.reason

        bankDetail.bank = data.bank
        bankDetail.bankAccountNo = data.bankAccountNo

        this.setState({ memberId, resumeFile, memberPayment: data.memberPayment }, () => { this.SearchTaxCertificate() })
        this.setState({ imageProfile, currentStatus, statusExpire})
        this.setState({ profile, reasonWorkList , bankDetail})
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }
  async SearchTaxCertificate() {
    try {
      const { memberId, selectYear } = this.state
      const R_memberId = this.props?.user?.lineId?.memberId
      const payload = { memberId: R_memberId, year: selectYear }
      const header = helper.GEN.toValueHeader(this.props)
      this.setState({ selectTaxYear: [] })
      const { resData } = await apiService.Profile.SearchTaxCertificate(payload, header)
      if(resData.resultCode === "20000"){
        const data = _.cloneDeep(resData.data)
        console.log('data >>', data)
        let { selectTaxYear } = this.state
        const MONTH = helper.CONFIG.MONTH
        selectTaxYear = data.map(d => ({ id: d.id, month: d.month ,name: MONTH[d.month], file: d.file }))
        this.setState({ selectTaxYear })
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }
  openFile(file, filename = '') {
    if (file){
      // window.open(file,'_blank')
      var myWindow = window.open("", "_blank");
      // myWindow.document.write("<p>I replaced the current window.</p>");
      const base64TypeData = `${file}`.split(',')
      let tmp = `${base64TypeData[0]}`.replace('data:', '').replace(';base64', '')
      const type = `${tmp}`.split('/')[1]
      console.log('type >>', type)
      let a = myWindow.document.createElement("a"); //Create <a>
      a.href = file; //Image Base64 Goes here
      a.download = filename + "." + type; //File name Here
      a.click();
    }
  }
  getValueById (arr = [], id ,key = 'id',value = 'name') {
    const findValue = arr.find(item => item[key] == id)
    if (findValue) {
      return findValue[value]
    }
    return '-'
  }

  render() {
    const { currentStatus, imageProfile, resumeFile, statusExpire } = this.state
    const { memberPayment } = this.state
    const { profile, reasonWorkList, bankDetail } = this.state
    const { selectTab, selectYear } = this.state
    const { taxYear_option, selectTaxYear } = this.state
    const { option } = this.props
    const memberStatus = this.props?.user?.lineId?.memberStatus
    const dayExpire = moment(statusExpire).diff(moment(),'days')
    return (
      <Layout>
        <div className="container-profile">
          <div className="header">
            <div className="main-header-text">ข้อมูลสมาชิก</div>
          </div>
          <div className="profile-body">
            <ProfileImage imageURL={imageProfile} />
            <div className="title-group">สถานะสมาชิก</div>
            <ProfileStatus status={currentStatus} expireDate={statusExpire} memberStatus={memberStatus} dayExpire={dayExpire} memberPayment={memberPayment}/>
            {/* {statusExpire}<br/> */}
            {/* {dayExpire} */}
            { memberStatus == 2 && currentStatus === 'Error' && <>
              <BButton setStyle="outline block" onClick={() => this.props.navigate(`/renew-member`)} >แจ้งชำระค่าสมาชิก</BButton>
              <div style={{ marginBottom: '18px' }}></div>
            </>
            }
            <hr className="space"/>
            { currentStatus === 'Success' && <ProfileTab selectTab={selectTab} setTab={(e) => this.setState({ selectTab: e } )}/> }
            { selectTab === 0 ?
              <main className="myprofile">
                <section className="sec-A">
                  <div className="title-group mb11">ข้อมูลส่วนตัว</div>
                  <InfoList left={'รหัสแนะนำของฉัน :'} right={profile.myRecommenderCode} />
                  <InfoList left={'เลขที่สมาชิก :'} right={profile.memberCode} />
                  <InfoList left={'ชื่อ - นามสกุล :'} right={profile.fullname} />
                  <InfoList left={'เลขที่บัตรประชาชน'} right={profile.identificationNo} />
                  <InfoList left={'วัน เดือน ปีเกิด'} right={profile.birthDate} />
                  <InfoList left={'เบอร์โทรศัพท์'} right={profile.phone} />
                  <InfoList left={'อีเมล'} right={profile.email} />
                  <InfoList left={'ที่อยู่'} right={profile.address} className='address'/>
                  <InfoList left={'เลขที่ใบประกอบวิชาชีพ'} right={profile.licenseNo} />
                  <InfoList left={'ตำแหน่ง'} right={this.getValueById(option.position, profile.position)} />
                  <InfoList left={'วุฒิการศึกษา'} right={this.getValueById(option.education, profile.educationQuality)} />
                </section>
                <section className="sec-B">
                  <div className="title-group mb14">ข้อมูลการทำงาน</div>
                  <div className="label-title">ประวัติการทำงาน</div>
                  { currentStatus === 'Error' || true
                    ? <BButton setStyle="outline2 block sp1" onClick={() => {
                        window.open(`${apiService.External.BaseFile}/open-file-download/Resume?id=${this.state.memberId}&type=resume`,'_blank')
                      }}>
                        <form style={{ pointerEvents: 'none' }} >
                          <input type="hidden" value={resumeFile} id="base64" name="base64"/>
                          <input id="loadfile" className="hidbtn" type="submit" value="ดู Resume"/>
                        </form>
                      </BButton>
                    : <div className="work-history">{ profile.workHistory }</div>
                  }
                  
                  <div className="title-group mb14">สิ่งที่เราอยากมาทำงาน รับงานที่นี่</div>
                  <ul className="list-detail">
                    { Array.isArray(reasonWorkList) && reasonWorkList.map(
                      (item, index) => <li key={index}>{ this.getValueById(option.nurseReason, item) }</li>
                    )}

                    { 
                      Array.isArray(reasonWorkList) && reasonWorkList.length === 0 && <div>-</div>
                    }
                  </ul>
                </section>
                <section className="sec-C">
                  <div className="title-group mt5 mb14">ข้อมูลบัญชีธนาคาร </div>
                  <InfoList left={'ธนาคาร'} right={ this.getValueById(option.bank, bankDetail.bank) } />
                  <InfoList left={'เลขที่บัญชี'} right={bankDetail.bankAccountNo} />
                </section>
                <section className="footer-action">
                  <BButton setStyle="sp1 block" Icon={<PenEdit />} onClick={() => this.props.navigate(`/editProfile`)} >แก้ไขข้อมูล</BButton>
                  { (currentStatus !== 'Error' && currentStatus !== 'Wait' && dayExpire <= 30) && <BButton setStyle="outline block" onClick={() => this.props.navigate(`/renew-member`)} >แจ้งชำระค่าสมาชิก</BButton> }
                </section>
              </main>
              :
              <main className="mytax">
                <div className="box-tax">
                  <Select
                    value={selectYear}
                    variant="standard"
                    onChange={(e) => this.setState({ selectYear: e.target.value } ,() => this.SearchTaxCertificate())}
                  >
                    { Array.isArray(taxYear_option) && taxYear_option.map(
                      (value, index) =>
                      <MenuItem key={index} value={value}>{value}</MenuItem>
                    )}
                  </Select>
                </div>
                <ul className="tax-file-list">
                { Array.isArray(selectTaxYear) && selectTaxYear.length >= 0 && selectTaxYear.map(
                  (item, index) =>
                  <>
                    <li key={'B' + item.id} onClick={() => {
                      // window.open(`${apiService.External.BaseFile}/open-file-download/ทวี50_${item.name}_${selectYear}?id=${item.id}&type=tax50`,'_blank')
                      window.open(item.file,'_blank')
                    }}>
                      <div className="filename">{ item.name }</div>
                      <div className="filedownload">
                        <FileDownload/>
                      </div>
                    </li>
                    <form key={'A' + item.id} className="hidtag" style={{ pointerEvents: 'none' }} >
                      <input type="hidden" value={item.file} id="base64" name="base64"/>
                      <input id="loadfiletax" type="submit" value="ดู Resume"/>
                    </form>
                  </>
                )}
                </ul>
              </main>
            }
          </div>
        </div>
      </Layout>
    );
  }
}
function ProfileRoute(props) {
  let navigate = useNavigate();
  return <Profile navigate={navigate} {...props}/>
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(ProfileRoute);
